import { Ajax } from "./ajax";
import * as workerPath from "file-loader?name=[name].js!./ajax.worker";
import Utils from '../util.js'

import { getToken } from "./environment";
import { isObject, isPromise } from "./share";
import Storage from "./stroage";
const storage = new Storage();

// import { href } from "./../../_h5/assets/js/system.action";
import store from "../../store/index"
import router from "../../router/index";

/** iOS / 安卓 App 内嵌 WebView：有原生桥时不应整页跳到 /h5/login，也不应使用 window.top（易顶到错误上下文） */
function isAppWebViewShell(): boolean {
    try {
        if (typeof window === "undefined") return false;
        const { isAndroid, isPhone } = Utils.os();
        if (!isAndroid && !isPhone) return false;
        const w: any = window;
        if (w.sonic && typeof w.sonic.getToken === "function") return true;
        const mh = w.webkit && w.webkit.messageHandlers;
        if (mh && mh.goLogin) return true;
        try {
            const q = router && router.currentRoute && router.currentRoute.query && router.currentRoute.query.type;
            if (q != null && String(q).toLowerCase() === "app") return true;
        } catch (e) {
            /* ignore */
        }
        return false;
    } catch (e) {
        return false;
    }
}

//接口弹层提示方法
const message = function (mag: string) {
    try {
        isMobile
            ? Notify({
                type: "warning",
                message: mag,
                "safe-area-inset-top": true
            })
            : ELEMENT.Message.error(mag);
    } catch (e) {
        alert(mag);
    }
};

//通行code码
const passCode: number[] = [
    600,
    -1010,
    -1000,
    0,
    200,
    -20001,
    100,
    101
];

export default class Http extends Ajax {
    //是否需要worker请求
    isWorkerRequest(object: any): boolean {
        //线上worker出现跨域问题， 暂时取消
        return false;
        if (location.href.includes("webworker=false")) {
            return false;
        }
        if (isObject(object.config) && object.config.webworker === false)
            return false;
        return true;
    }

    //请求拦截器
    InjectRequest(object: any): any {
        //这里可以做一些全局性的请求设置
        //Promise.reject()拦截 进行 其他操作
        //比如下方转到 worker
        //.....
        // 请求头里面加 x-token字段（登录改造）
        const xToken = localStorage.getItem('x-token')
        if (xToken && !object.headers['x-token']) {
            object.headers['x-token'] = xToken
        }

        const urls = ['/spot-a/', '/spot-o/','/spot/', '/bsapi', '/bsoapi']
        const isSpotGoodsUrl =  urls.some(item => object.url.indexOf(item)>-1)
        const userId = store.getters.getUserInfo?.id
        
        // 现货接口，增加 X-USER-ID
        if (isSpotGoodsUrl) {
            object.headers['X-USER-ID'] = userId;
        }
        // 所有接口请求头增加 ts
        if (!object.headers['ts']) {
            object.headers['ts'] = new Date().getTime()
        }
        object.headers.terminalKey = 'exchange'
        const runtimeLocale = (_i18n && _i18n.locale) ? _i18n.locale : ''
        let lang = runtimeLocale || localStorage.getItem('_language')
        // 统一回写，避免跨页面后 localStorage 语言滞后
        if (lang) {
            localStorage.setItem('_language', lang)
        }
        // object.headers.language = object.headers.lang = _i18n.locale;
        object.headers.language = object.headers.lang = lang;
        object.headers.token = getToken();
        object.headers.withCredentials = true;
        object.headers['x-locale'] = lang;
        if (!object.headers['clientTag']) {
            const whiteList = [
                '/excellent/app/otc/itez/v2/run',
                '/excellent/app/otc/itez/v2/orderedId'
            ]
            const isWhite = whiteList.some(item => object.url.indexOf(item) > -1)
            const {
              isPc,
              isAndroid,
              isPhone,
              isTablet
            } = Utils.os()
            // const tag = (isPc || isWhite) ? 'WEB': (isPhone? 'IOS': 'ANDROID')
            const tag = isWhite ? (isPhone? 'IOS': 'ANDROID') :(isPhone? 'H5_IOS': (isAndroid || isTablet)? 'H5_ANDROID': 'WEB')
            object.headers['clientTag'] = tag;
        }
        //不知道为啥2个token，2.0重构时与网关字段冲突，识别到deviceId，则取消掉loginToken的传递（有一定风险）
        if(!object.headers.deviceId) object.headers.loginToken = getToken();
        // object.headers.token = "fa320603-f4a7-4354-bd5b-9160a5b51325";

        object.headers["X-Requested-With"] = "XMLHttpRequest";
        //是否添加计价方式头
        const type = localStorage.getItem("selectType");
        if (type) {
            object.headers.selectType = type;
        } else {
            object.headers.selectType = "USD";
        }
        //主线程
        if (!this.isWorkerRequest(object)) return object;
        else return this.middleWorker(object);
    }

    //响应拦截器
    InterctResponse(config: any, promise: any, response: any) {
        // 这里可以做一些全局性的拦截设置
        // Promise.reject(response)拦截
        // .....
        let data: any = {}
        const {responseURL, responseText} = response
        const whiteList = [
            '/v2/public/web/login',
            '/excellent/otc/finance/v2/financialReport',
            '/excellent/user/asset/v2/findPage',
            '/copytrading/api/v2/client/leader/reqLeader',
            '/excellent/app/otc/itez/v2/run',
            '/excellent/app/otc/itez/v2/orderedId',
            '/spot-o/open/api/v2/market/getDexPairs',
            '/spot-o/open/api/v2/market/getDexPrice'
            // '/excellent/user/v2/video/upload'
        ]
        const isWhite = whiteList.some(item => responseURL.indexOf(item)> -1)
        // 文件下载
        if (responseURL.indexOf('/excellent/otc/finance/v2/financialReport')> -1) {
            response.responseType = 'blob'
        }
        // && process.env.NODE_ENV  != 'development'
        if (!isWhite && process.env.NODE_ENV != 'development') {
            try {
                const res = Utils.DecryptoWithParams(responseText)
                data = JSON.parse(decodeURIComponent(res.replace(/\+/g, '%20')))
            } catch (error) {
                console.log('error:::',error);
            }
            
        } else {
            data = JSON.parse(response.response || "{}");
        }
        // else {

        //     if (response.response.indexOf('"code"') === -1) {
        //         const res = Utils.DecryptoWithParams(responseText)
        //         data = JSON.parse(decodeURIComponent(res.replace(/\+/g, '%20')))
        //     } else {
        //         data = JSON.parse(response.response || "{}");

        //     }

        // }
        

        // setTimeout(()=>{console.info(config.url,'--',data)},300)
        // const data = JSON.parse(response.response || "{}");
        //返回promise继续响应
        //return promise;
        //网络错误
        if (response.status !== 200) {
            if (response.status == 401) {
                return message(data.msg)
            } else {
                return this.responseStatusError();
            }
        }

        //通行
        if (isPromise(this.responseStatus200(data)))
            return Promise.resolve(data);

        // 下单需要验证交易密码
        if (data.code == 200017) {
          return Promise.resolve(data);
        }

        //未登录
        if (data.code == 401 || data.code == 402) {
            console.error("跳登录", response);
            this.responseCode401();
            return;
        }

        //接口错误弹层
        this.responseStatusMessage(data);
        return Promise.reject(response);
    }

    clearCookie() {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        const host = window.location.hostname.slice(window.location.hostname.indexOf('.')+1)
        if (keys) {
            for (var i = keys.length; i--;) {
                if((['CONTRACT_TOKEN', 'exchangesessionid'] as any).includes(keys[i])){
                    document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
                    document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的
                    document.cookie = keys[i] + '=0;path=/;domain='+host+';expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
                }
            }
        }
    }

    responseStatusError() {
        // message("网络错误");
        return Promise.reject();
    }
    responseStatus200(data: any) {
        if (
            passCode.indexOf(+data.code) > -1 ||
            (data.code && data.code.length === 3 && data.code.split("")[0] == 1)
        ) {
            return Promise.resolve(data);
        } else if (data.errno && data.errno === "OK") {
            return Promise.resolve(data);
        } else if(data.code === 200){
            return Promise.resolve(data);
        }
    }
    responseStatusMessage(data: any) {
        //接口错误弹层
        // let key =
        //     data.i18nMsgCode &&
        //     data.i18nMsgCode.replace("error.", "").replace(/\./g, "_");
        // let msg = _i18n.messages[_i18n.locale].res[key];
        // console.log('msg:::', msg);
        
        data.msg && message(data.msg);
        data.message && message(data.message);
    }
    responseCode401() {
        //移除用户信息
        this.clearCookie()
        storage.removeStorageSync("userMenu");
        storage.removeStorage('x-token')
        localStorage.removeItem('x-token')
        store.commit('CLEAR_AUTH_SESSION');
        store.commit('REMOVE_FOLLOW_SIGN')
        store.commit("REMOVE_ACCOUNTBANALCE")
        console.warn(
            "*****responseCode401***** :",
            window.isMobile,
            location.href
        );
        const agentid = sessionStorage.getItem('agentid')
        if (window.isMobile) {
            if (isAppWebViewShell()) {
                return;
            }
            if (agentid) {
                window.top.location.href = '/h5/login?agentid='+agentid
            } else {
                window.top.location.href = '/h5/login'
            }
            return
        }
        if (agentid) {
            router.push({path: '/v3/user/login', query: {agentid}})
        } else {
            router.push({path: '/v3/user/login'})
        }
    }

    //worker入口函数
    async middleWorker(object: any) {
        let data = null;
        let result = await this.worker(object).then(res => {
            data = res;
            return res;
        });
        if (this.isProxy(object)) {
            this.delProxy(object);
        }
        let promise = Promise.resolve(result);
        return this.InterctResponse(object, promise, data);
    }
    //worker实现函数
    worker(object: any) {
        return new Promise((reslove, reject) => {
            let worker = new Worker(workerPath);
            // worker.postMessage(JSON.stringify(object));
            worker.postMessage(object);
            worker.onmessage = e => {
                worker.terminate();
                worker = null;
                reslove(JSON.parse(e.data));
            };
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/ts/ajax.config.ts